//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'
import ArrayStore from 'devextreme/data/array_store'
import { locale as globalizeLocale } from 'globalize'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { ScheduleConfigurationModel, ConfigurationProfileFunctionModel } from '../../api/api.models'
import { i18n } from '../i18n/common.i18n'
import { CommonHelper, DeviceFunctionType } from '../../../helpers/common-helper'
import { EventsNames } from '../../../helpers/events-names'
import { Permissions } from '../../../helpers/permissions'
import { TemplateHelper, ConfigHelper, IUserSession } from '../../../helpers'
import { IMRBaseControlDirectiveController } from '../base'

interface ScheduleScope extends ng.IScope {
    modelId: number

    form: DevExpress.ui.dxForm
    scheduleFormOptions: DevExpress.ui.dxFormOptions
    scheduleForm: DevExpress.ui.dxForm
    topToolbarOptions: DevExpress.ui.dxToolbarOptions
    toolbarOptions: DevExpress.ui.dxToolbarOptions
    daysOfWeek: boolean[]

    editSchedulePopupOptions: DevExpress.ui.dxPopupOptions
    editPopupVisible: boolean
    lessMoreClick: () => void
    lessMoreText: string
    daysButtons: DevExpress.ui.dxButtonOptions[]
    selectedDay: number[]
    //hourValue: Date    

    checkBoxEnable: DevExpress.ui.dxCheckBoxOptions
    checkBoxLocalTime: DevExpress.ui.dxCheckBoxOptions
    hourDateBox: DevExpress.ui.dxDateBoxOptions
    selectBoxMinuteType: DevExpress.ui.dxSelectBoxOptions
    numberBoxMinute: DevExpress.ui.dxNumberBoxOptions
    selectBoxDateType: DevExpress.ui.dxSelectBoxOptions
    numberBoxDate: DevExpress.ui.dxNumberBoxOptions
    numberBoxDateDisabled: boolean

    lessMore: boolean
    minuteSelectDisabled: boolean


    editButton: DevExpress.ui.dxButtonOptions
    idConfigurationProfile: number
    profilesList: ConfigurationProfileFunctionModel[]
    schedules: ConfigurationProfileFunctionModel[]
    daysFirstLetter: { id: number, letter: string }[]
    daysNamesLocalized: DaysNamesModel[]
    possibleToAddShedule: boolean

    allowedToAdd: boolean
    allowedToEdit: boolean
    needHideLoader: boolean

    prepareEveryDateText: (dayId: number[]) => string
}

interface DaysNamesModel {
    id: number,
    short: string,
    wide: string
}


export class ScheduleController extends IMRBaseControlDirectiveController {
    private secondFormVisible: boolean = false //

    private checkBoxEnable: DevExpress.ui.dxCheckBox
    private checkBoxLocalTime: DevExpress.ui.dxCheckBox
    private selectBoxMinuteType: DevExpress.ui.dxSelectBox
    private numberBoxMinute: DevExpress.ui.dxNumberBox
    private selectBoxDate: DevExpress.ui.dxSelectBox
    private numberBoxDate: DevExpress.ui.dxNumberBox
    private hourDateBox: DevExpress.ui.dxDateBox
    private daysButtons: DevExpress.ui.dxButton[]

    private daysNames: DaysNamesModel[] = []
    private externalEvent: boolean = false
    private schedulesList: ScheduleConfigurationModel[] = []
    private toEdit: ScheduleConfigurationModel
    private idToEdit: number = null
    private selectedDay: number[] = []

    constructor(private $scope: ScheduleScope, private $q: ng.IQService, private $timeout: ng.ITimeoutService, private api: Api, private localDictionary: LocalDictionaryFactory, private userSession: IUserSession) {
        super()

        //START schedule list section
        $scope.possibleToAddShedule = false
        $scope.needHideLoader = true
        Permissions.hasPermissions([Permissions.SCHEDULE_ADD, Permissions.CONFIGURATION_PROFILE_ADD]).then(permission => {
            $scope.allowedToAdd = permission
        })
        Permissions.hasPermissions([Permissions.SCHEDULE_EDIT, Permissions.CONFIGURATION_PROFILE_EDIT]).then(permission => {
            $scope.allowedToEdit = permission
        })

        $timeout(() => {
            $scope.schedules = $scope.profilesList.filter(item => { return item.deviceFunctionType == DeviceFunctionType.Schedule })

            this.prepareDayOfWeek()

            if ($scope.schedules.length < 20)
                $scope.possibleToAddShedule = true
        })

        $scope.daysNamesLocalized = this.daysDataSource() || []
        this.daysNames = (<any>Object).assign([], $scope.daysNamesLocalized)
        $scope.daysFirstLetter = $scope.daysNamesLocalized.map((item) => { return { id: item.id, letter: item.short.charAt(0) } })

        $scope.selectedDay = [1, 2, 3, 4, 5, 6, 7, 255] //by default selected all days

        $scope.editButton = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.EDIT, userSession),
            hint: i18n('Common', 'EditSchedule'),
            onClick: (e) => {
                $scope.needHideLoader = false
                this.idToEdit = e.model.field.indexNbr
                $scope.selectedDay = e.model.field.dayOfWeek
                this.prepareCreateEditPopup(e.model.field.indexNbr)
            },
            bindingOptions: {
                disabled: '!allowedToEdit'
            }
        }

        $scope.topToolbarOptions = {
            items: [{
                location: 'after',
                widget: 'dxButton',
                options: {
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.ADD, userSession),
                    hint: i18n('Common', 'AddNewSchedule'),
                    onClick: () => {
                        $scope.needHideLoader = false
                        this.idToEdit = null
                        this.prepareCreateEditPopup()
                    },
                    bindingOptions: {
                        disabled: '!possibleToAddShedule' || '!allowedToAdd'
                    }
                }
            }]
        }

        $scope.prepareEveryDateText = (dateIds) => {
            var result = ''
            if (dateIds[7] != 255) {
                var days: string = ' ('
                dateIds.forEach((id, index) => {
                    if (id) {
                        if (days != ' (') {
                            days += ', '
                        }
                        days += $scope.daysNamesLocalized[index].short
                    }
                })
                if (days != ' (') {
                    result += days += ')'
                }
            }

            return result
        }
        //END schedule list section

        //START schedule popup section
        $scope.editPopupVisible = false

        $scope.editSchedulePopupOptions = {
            title: i18n('Common', 'EditSchedule'),
            maxWidth: 800,
            height: 400,
            bindingOptions: {
                visible: 'editPopupVisible'
            },
            onHiding: e => {

            }
        }

        $scope.toolbarOptions = {
            items: [{
                location: 'after',
                widget: 'dxButton',
                options: {
                    text: i18n('Common', 'Cancel'),
                    onClick: () => {
                        $scope.editPopupVisible = false
                    }
                }
            }, {
                location: 'after',
                widget: 'dxButton',
                options: {
                    text: i18n('Common', 'Save'),
                    onClick: () => {
                        $scope.needHideLoader = false
                        var result: ScheduleConfigurationModel = this.getFormValues()
                        if (this.idToEdit == null) {
                            var indexes = this.$scope.profilesList.map(item => { return item.indexNbr })
                            if (indexes.length == 0)
                                indexes = [-1]

                            var max = indexes.reduce((a, b) => {
                                return Math.max(a, b);
                            })
                            result.indexNbr = max + 1
                        }
                        this.api.location.saveConfigurationProfile(result).then((result: ScheduleConfigurationModel) => {
                            CommonHelper.openInfoPopup(i18n('Popup', 'ScheduleSaved'))
                            this.$scope.$root.$broadcast(EventsNames.UPDATE_CONFIGURATION_PROFILE_FUNCTION_LIST, result)
                            this.updateSchedules(result)
                            $scope.editPopupVisible = false
                            $scope.needHideLoader = false
                        }).catch(reason => {
                            CommonHelper.openInfoPopup(i18n('Popup', 'ScheduleSaveError'), 'error', 5000)
                        })
                    }
                }
            }
            ]
        }

        $scope.lessMoreClick = () => {
            $scope.lessMore = !$scope.lessMore
            if ($scope.lessMoreText == i18n('Common', 'More'))
                $scope.lessMoreText = i18n('Common', 'Less')
            else
                $scope.lessMoreText = i18n('Common', 'More')
        }

        $scope.lessMoreText = i18n('Common', 'More')
        $scope.lessMore = false
        //END schedule popup section
    }

    prepareButtonsGroup(selectedDay: number[] = [1, 2, 3, 4, 5, 6, 7, 255], needAllBtn: boolean = true) {
        this.$scope.daysButtons = []
        this.daysButtons = []
        this.daysNames = (<any>Object).assign([], this.$scope.daysNamesLocalized)
        if (needAllBtn) this.daysNames.push({ id: 255, short: i18n('Common', 'All'), wide: i18n('Common', 'All') })
        if (selectedDay[7] == 255) selectedDay = [1, 2, 3, 4, 5, 6, 7, 255]
        this.$timeout(() => {
            this.selectedDay = selectedDay
            this.daysNames.forEach((day, index) => {
                var btnType: 'default' | 'normal' = 'default'
                if (selectedDay[7] == 255) {
                    btnType = 'default'
                }
                else {
                    if (selectedDay[index]) {
                        btnType = 'default' // blue
                    }
                    else {
                        btnType = 'normal' //white
                    }
                }

                var itemBtn = <DevExpress.ui.dxButtonOptions>{
                    name: 'day_' + day.short,
                    hoverStateEnabled: false,
                    type: btnType,
                    hint: day.wide,
                    onClick: e => {
                        if (day.id == 255) {
                            if (this.selectedDay[7]) {
                                this.daysButtons.forEach((btn, indx) => {
                                    btn.option('type', 'normal')
                                })
                                this.selectedDay = []
                            } else {
                                this.daysButtons.forEach((btn, indx) => {
                                    btn.option('type', 'default')
                                })
                                this.selectedDay = [1, 2, 3, 4, 5, 6, 7, 255]
                            }
                        } else {
                            if (this.selectedDay[day.id - 1]) {
                                e.component.option('type', 'normal')
                                this.selectedDay[day.id - 1] = null
                            }
                            else {
                                e.component.option('type', 'default')
                                this.selectedDay[day.id - 1] = day.id
                            }
                            var all: number = 0
                            this.selectedDay.forEach((item, index) => {
                                if (index != 7 && item)
                                    all++
                            })
                            if (all == 7) {
                                this.selectedDay[7] = 255
                                this.daysButtons[255].option('type', 'default')
                            } else {
                                this.selectedDay[7] = null
                                this.daysButtons[255].option('type', 'normal')
                            }
                        }
                    },
                    onInitialized: e => {
                        this.daysButtons[day.id] = e.component
                    }
                }
                if (day.id != 255)
                    itemBtn.text = day.short
                if (day.id == 255)
                    itemBtn.template = TemplateHelper.getIcon(ConfigHelper.Icon.DONE_ALL, this.userSession)
                this.$scope.daysButtons.push(itemBtn)
            })
        })
    }

    datesDataScource() {
        var items: number[] = []
        var i = 1
        do {
            items.push(i++)
        }
        while (i < 32)
        return items
    }

    daysDataSource() {
        var items: DaysNamesModel[] = []

        // TODO dodać localization service
        var short = globalizeLocale().main('dates/calendars/gregorian/days/format/short')
        var wide = globalizeLocale().main('dates/calendars/gregorian/days/format/wide')
        var i = 0
        for (var prop in short) {
            items[i] = {
                id: i + 1,
                short: short[prop].charAt(0).toUpperCase() + short[prop].slice(1),
                wide: wide[prop].charAt(0).toUpperCase() + wide[prop].slice(1)
            }
            i++
        }
        return items
    }

    getFormValues() {
        var result: ScheduleConfigurationModel = <ScheduleConfigurationModel>{}

        result.isEnable = this.checkBoxEnable.option('value')
        if (<Date>this.hourDateBox.option('value'))
            result.hourOfDay = (<Date>this.hourDateBox.option('value')).getHours()
        else
            result.hourOfDay = 255
        result.isLocalTime = this.checkBoxLocalTime.option('value')
        var minuteType = this.selectBoxMinuteType.option('value')
        if (minuteType == 1) {
            result.minutesOfHour = this.numberBoxMinute.option('value')
        }
        if (minuteType == 2) {
            result.minutesOfHour = 60 + this.numberBoxMinute.option('value')
        }
        var dateType = this.selectBoxDate.option('value')
        if (dateType == 1) {
            result.dayOfMonth = this.numberBoxDate.option('value')
        }
        if (dateType == 2) {
            result.dayOfMonth = -128 + (this.numberBoxDate.option('value') - 1)
        }
        if (dateType == null) {
            result.dayOfMonth = 255
        }
        result.dayOfWeek = []
        if (this.selectedDay[7])
            result.dayOfWeek = [255]
        else
            this.selectedDay.forEach(item => {
                if (item)
                    result.dayOfWeek.push(item)
            })
        result.deviceFunctionType = DeviceFunctionType.Schedule

        result.idConfigurationProfile = this.$scope.idConfigurationProfile
        result.indexNbr = this.idToEdit
        return result
    }

    resetForm() {
        if (this.checkBoxEnable) this.checkBoxEnable.option({ value: false })
        if (this.hourDateBox) this.hourDateBox.reset()
        if (this.checkBoxLocalTime) this.checkBoxLocalTime.option({ value: false })
        if (this.selectBoxMinuteType) this.selectBoxMinuteType.reset()
        if (this.numberBoxMinute) this.numberBoxMinute.option({ value: 0 })
        if (this.selectBoxDate) this.selectBoxDate.reset()
        if (this.numberBoxDate) this.numberBoxDate.option({ value: 0 })
        this.prepareButtonsGroup()
    }

    prepareCreateEditPopup(id: number = null) {
        this.$scope.checkBoxEnable = {
            value: false,
            onInitialized: e => {
                this.checkBoxEnable = e.component
            }
        }

        this.$scope.checkBoxLocalTime = {
            value: true,
            onInitialized: e => {
                this.checkBoxLocalTime = e.component
            }
        }

        this.$scope.hourDateBox = {
            type: 'time',
            pickerType: 'rollers',
            displayFormat: 'HH:mm',
            showClearButton: true,
            onInitialized: e => {
                this.hourDateBox = e.component
            },
            placeholder: i18n('Common', 'AllHours'),
            onValueChanged: e => {
                if (e.value && !this.externalEvent) {
                    this.selectBoxMinuteType.option({ value: 1 })
                    this.$timeout(() => {
                        this.numberBoxMinute.option({ value: (<Date>e.value).getMinutes() })
                    })
                }
                if (e.value == null) {
                    this.selectBoxMinuteType.option({ value: 2 })
                }
                this.externalEvent = false
            }
        }

        this.$scope.selectBoxMinuteType = {
            dataSource:
                new DataSource(new ArrayStore({
                    data: [{ id: 1, value: i18n('Common', 'SetMinutes') }, { id: 2, value: i18n('Common', 'EveryXMinutes') }],
                    key: "id"
                })),
            displayExpr: 'value',
            valueExpr: 'id',
            onSelectionChanged: e => {
                if (e.selectedItem) {
                    this.$scope.minuteSelectDisabled = false
                    if (e.selectedItem.id == 1) {
                        if (this.numberBoxMinute) this.numberBoxMinute.option({ min: -1 })
                        if (this.toEdit && this.toEdit.minutesOfHour >= 0 && this.toEdit.minutesOfHour < 60) {
                            this.$timeout(() => {
                                this.numberBoxMinute.option({ value: this.toEdit.minutesOfHour })
                            })
                        } else {
                            this.numberBoxMinute.option({ value: 0 })
                        }
                    }
                    if (e.selectedItem.id == 2) {
                        if (this.hourDateBox.option('value')) {
                            this.externalEvent = true
                            var date = new Date()
                            date.setHours(this.hourDateBox.option('value').getHours())
                            date.setMinutes(0)
                            this.$timeout(() => {
                                this.hourDateBox.option({ value: date })
                            })
                        }

                        if (this.numberBoxMinute) {
                            this.numberBoxMinute.option({ min: 0 })
                            if (this.toEdit && this.toEdit.minutesOfHour > 60) {
                                this.numberBoxMinute.option({ value: this.toEdit.minutesOfHour - 60 })
                            }
                            else {
                                this.numberBoxMinute.option({ value: 1 })
                            }
                        }
                    }
                }
                else {
                    this.$scope.minuteSelectDisabled = true
                }
            },
            onInitialized: e => {
                this.selectBoxMinuteType = e.component
            },
            placeholder: i18n('Common', 'SelectMinuteType')
        }

        this.$scope.minuteSelectDisabled = true
        this.$scope.numberBoxMinute = {
            min: -1,
            max: 60,
            showSpinButtons: true,
            onInitialized: e => {
                this.numberBoxMinute = e.component
            },
            value: 0,
            placeholder: i18n('Common', 'SetMinutes'),
            onValueChanged: e => {
                if (e.value == this.numberBoxMinute.option('max')) {
                    this.numberBoxMinute.option({ value: this.numberBoxMinute.option('min') + 1 })
                }
                if (e.value == this.numberBoxMinute.option('min')) {
                    this.numberBoxMinute.option({ value: this.numberBoxMinute.option('max') - 1 })
                }

                if (this.selectBoxMinuteType.option('value') == 1 && this.hourDateBox.option('value')) {
                    var date = new Date()
                    date.setHours((<Date>this.hourDateBox.option('value')).getHours())
                    date.setMinutes(e.value)
                    this.externalEvent = true
                    this.hourDateBox.option({ value: date })
                }
            },
            bindingOptions: {
                disabled: 'minuteSelectDisabled'
            }
        }

        this.$scope.selectBoxDateType = {
            dataSource:
                new DataSource(new ArrayStore({
                    data: [{ id: 1, value: i18n('Common', 'SelectDate') }, { id: 2, value: i18n('Common', 'DayFromTheEnd') }],
                    key: "id"
                })),
            displayExpr: 'value',
            valueExpr: 'id',
            onSelectionChanged: e => {
                if (e.selectedItem) {
                    this.$scope.numberBoxDateDisabled = false
                } else {
                    this.$scope.numberBoxDateDisabled = true
                }
            },
            onInitialized: e => {
                this.selectBoxDate = e.component
            },
            placeholder: i18n('Common', 'SelectDateType'),
            showClearButton: true
        }

        this.$scope.numberBoxDateDisabled = true
        this.$scope.numberBoxDate = {
            min: 1,
            max: 31,
            value: 0,
            showSpinButtons: true,
            bindingOptions: {
                disabled: 'numberBoxDateDisabled'
            },
            onInitialized: e => {
                this.numberBoxDate = e.component
            },
            placeholder: i18n('Common', 'SelectDay')
        }

        if (id != null) {
            if (this.hourDateBox) this.hourDateBox.reset()
            if (this.selectBoxMinuteType) this.selectBoxMinuteType.reset()
            if (this.numberBoxMinute) this.numberBoxMinute.reset()
            this.toEdit = <ScheduleConfigurationModel>this.$scope.schedules.filter(item => { return item.indexNbr == id })[0]
            this.$scope.checkBoxEnable.value = this.toEdit.isEnable
            if (this.checkBoxEnable) this.checkBoxEnable.option({ value: this.toEdit.isEnable })
            this.$scope.checkBoxLocalTime.value = this.toEdit.isLocalTime
            if (this.checkBoxLocalTime) this.checkBoxLocalTime.option({ value: this.toEdit.isLocalTime })
            if (this.toEdit.minutesOfHour > 60) {
                if (this.toEdit.hourOfDay) {
                    var date = new Date()
                    date.setHours(this.toEdit.hourOfDay)
                    date.setMinutes(0)
                    this.$timeout(() => {
                        this.externalEvent = true
                        this.$scope.hourDateBox.value = date
                        if (this.hourDateBox) this.hourDateBox.option({ value: date })
                    })
                }

                this.externalEvent = true
                this.$scope.selectBoxMinuteType.value = 2
                if (this.selectBoxMinuteType) this.selectBoxMinuteType.option({ value: 2 })
                this.externalEvent = true
                this.$scope.numberBoxMinute.value = this.toEdit.minutesOfHour - 60
                if (this.numberBoxMinute) this.numberBoxMinute.option({ value: this.toEdit.minutesOfHour - 60 })
                this.externalEvent = false
            } else {
                if (this.toEdit.hourOfDay) {
                    var date = new Date()
                    date.setHours(this.toEdit.hourOfDay)
                    date.setMinutes(this.toEdit.minutesOfHour)
                    this.$timeout(() => {
                        this.externalEvent = true
                        this.$scope.hourDateBox.value = date
                        if (this.hourDateBox) this.hourDateBox.option({ value: date })
                    })
                }

                this.externalEvent = true
                this.$scope.selectBoxMinuteType.value = 1
                if (this.selectBoxMinuteType) this.selectBoxMinuteType.option({ value: 1 })
                this.$scope.numberBoxMinute.value = this.toEdit.minutesOfHour
                if (this.numberBoxMinute) this.numberBoxMinute.option({ value: this.toEdit.minutesOfHour })
                this.externalEvent = false
            }

            if (this.toEdit.dayOfMonth != null) {
                if (this.toEdit.dayOfMonth > 0) {
                    if (this.toEdit.dayOfMonth == 255) {
                        this.$scope.selectBoxDateType.value = null
                        if (this.selectBoxDate) this.selectBoxDate.option({ value: null })
                        this.$scope.numberBoxDate.value = null
                        if (this.numberBoxDate) this.numberBoxDate.option({ value: null })
                        this.$scope.numberBoxDateDisabled = true
                    } else {
                        this.$scope.selectBoxDateType.value = 1
                        if (this.selectBoxDate) this.selectBoxDate.option({ value: 1 })
                        this.$scope.numberBoxDate.value = this.toEdit.dayOfMonth
                        if (this.numberBoxDate) this.numberBoxDate.option({ value: this.toEdit.dayOfMonth })
                        this.$scope.numberBoxDateDisabled = false
                    }
                }
                if (this.toEdit.dayOfMonth < 0) {
                    this.$scope.selectBoxDateType.value = 2
                    if (this.selectBoxDate) this.selectBoxDate.option({ value: 2 })
                    this.$scope.numberBoxDate.value = this.toEdit.dayOfMonth + 129
                    if (this.numberBoxDate) this.numberBoxDate.option({ value: this.toEdit.dayOfMonth + 129 })
                    this.$scope.numberBoxDateDisabled = false
                }
            } else {
                this.$scope.selectBoxDateType.value = null
                if (this.selectBoxDate) this.selectBoxDate.reset()
                this.$scope.numberBoxDate.value = null
                if (this.numberBoxDate) this.numberBoxDate.option({ value: null })
            }

            this.prepareButtonsGroup((<any>Object).assign([], this.toEdit.dayOfWeek))
        }
        else {
            this.toEdit = null
            this.resetForm()
        }
        this.$scope.editPopupVisible = true
        this.$scope.needHideLoader = true
    }

    updateSchedules(result: ScheduleConfigurationModel) {
        if (this.idToEdit != null) {
            this.$scope.profilesList = this.$scope.profilesList.map((profile) => {
                var item = <ScheduleConfigurationModel>{}
                if (profile.indexNbr == this.idToEdit) {
                    item.dayOfMonth = result.dayOfMonth
                    item.dayOfWeek = result.dayOfWeek
                    item.hourOfDay = result.hourOfDay
                    item.indexNbr = result.indexNbr
                    item.isEnable = result.isEnable
                    item.isLocalTime = result.isLocalTime
                    item.minutesOfHour = result.minutesOfHour
                    item.deviceFunctionType = result.deviceFunctionType
                    item.idConfigurationProfile = result.idConfigurationProfile
                    return item
                }
                return profile
            })
            this.$scope.schedules = this.$scope.profilesList.filter(item => { return item.deviceFunctionType == DeviceFunctionType.Schedule })
            this.prepareDayOfWeek()
        } else {
            this.$scope.schedules.push(result)
            this.prepareDayOfWeek()
        }

        this.$scope.schedules = this.$scope.schedules.map(item => {
            if (item.indexNbr == result.indexNbr) {
                var model = <ScheduleConfigurationModel>item
                if (model.hourOfDay == 255)
                    model.hourOfDay = null
                return model
            }
            return item
        })
        if (this.$scope.schedules.length < 20)
            this.$scope.possibleToAddShedule = true
        else
            this.$scope.possibleToAddShedule = false
    }

    prepareDayOfWeek() {
        this.$scope.schedules.forEach((schedule: ScheduleConfigurationModel) => {
            let tempDays: number[] = []
            schedule.dayOfWeek.forEach(day => {
                if (day == 255) {
                    tempDays[7] = 255 //selecteed all days                    
                }
                else {
                    if (day > 0 && day < 8) {
                        tempDays[day - 1] = day
                    }
                }
            })
            schedule.dayOfWeek = tempDays
        })
    }
}

